// MUI & Component Imports
import { useState } from 'react';
import BidderDetails from './Bidders/BidderDetails';
import TextInput from './TextFieldComponent';
import DropDownSingle from '../../../../Components/DropDownSingle/index.jsx';
import BidderDropdown from './DropDownComponent';
import TYPES from './constants.json';
import { toast } from 'react-toastify';
import ErrorBoundary from '../../../../Components/CustomErrorBoundary/CustomErrorBoundary';

// Initializing constants
const { INPUT_TYPES, RELATION_OPTIONS } = TYPES;

const BidderCard = ({ bidderData, bidderTypes, updateBidder, deleteBidder, bidderIndex }) => {
	if (!bidderData || !bidderTypes || bidderIndex === undefined) {
		toast.error('Bidder data, types, or index are missing.', { position: 'bottom-right' });
	}
	const initialRelation = bidderData && bidderData.isDirectRelation === true
		? RELATION_OPTIONS.Direct
		: RELATION_OPTIONS.Adpushup; // default to Adpushup if not specified
	const [bidderRelation, setBidderRelation] = useState(initialRelation);
	const bidderName = bidderData?.bidder;
	const bidderParams = bidderData?.params;
	const bidderConfig = bidderTypes?.[bidderName]?.params;

	if (!bidderName || !bidderParams || !bidderConfig) return null;

	const params = Object.entries({
		...bidderConfig.global,
		...bidderConfig.siteLevel,
		...bidderConfig.adUnitLevel
	});

	const visibleFields = params.filter(([_, config]) => config?.visible);

	const filteredConfig = visibleFields.reduce(
		(acc, [key, config]) => ({ ...acc, [key]: config }),
		{}
	);

	return (
		<ErrorBoundary>
			<BidderDetails
				bidder={bidderName}
				bidderIndex={bidderIndex}
				deleteBidder={deleteBidder}
				key={bidderIndex}
			>
				{Object.entries(bidderParams).map(([paramKey, paramValue]) => {
					const config = filteredConfig[paramKey];
					if (!config) return null;

					if (config.inputType === INPUT_TYPES.DROPDOWN && Array.isArray(config.options)) {
						return (
							<BidderDropdown
								key={paramKey}
								value={paramValue}
								label={config.name || paramKey}
								options={config.options}
								editable={config.isEditable}
								onChange={(val) => {
									const updatedBidder = structuredClone(bidderData);
									updatedBidder.params[paramKey] = val;
									updateBidder(updatedBidder, bidderIndex);
								}}
							/>
						);
					}
					return (
						<TextInput
							key={paramKey}
							val={paramValue}
							label={config.name || paramKey}
							editable={config.isEditable}
							inputType={config.dataType || INPUT_TYPES.TEXT}
							onChange={(val) => {
								const updatedBidder = structuredClone(bidderData);
								if (config.dataType === INPUT_TYPES.NUMBER) {
									updatedBidder.params[paramKey] = Number(val);
								} else {
									updatedBidder.params[paramKey] = val;
								}
								updateBidder(updatedBidder, bidderIndex);
							}}
						/>
					);
				})}
				{/* <DropDownSingle
					list={Object.values(RELATION_OPTIONS)}
					isObjectEditor={false}
					directValue={bidderRelation}
					updateDirectValue={(value) => {
						setBidderRelation(value);
						const updatedBidder = structuredClone(bidderData);

						const isDirectBidderRelation = value === RELATION_OPTIONS.Direct;
						updatedBidder.isDirectRelation = isDirectBidderRelation;
						updateBidder(updatedBidder, bidderIndex);
					}}
					formControlStyles={{ width: '100%' }}
					formControlVariant={'outlined'}
					containerStyles={{ width: '100%' }}
					label="Relation Type"
					labelStyles={{ "font-size": '1.5rem' }}
				/> */}
			</BidderDetails>
		</ErrorBoundary>
	);
};

export default BidderCard;
